module.exports = __webpack_public_path__ + "static/media/marker-you.eb7e9dfc.svg";